import { CenteredPage } from '@cmg/common';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { ForgotPasswordFormValues } from './components/ForgotPasswordForm';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import { forgotPassword, resetState, selectError, selectSubmitting, selectSuccess } from './ducks';

export const ForgotPasswordRouteComponent: React.FC = () => {
  const dispatch = useDispatch();
  const submitting = useSelector(selectSubmitting);
  const error = useSelector(selectError);
  const success = useSelector(selectSuccess);

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);

  const handleSubmit = useCallback(
    (values: ForgotPasswordFormValues) => {
      dispatch(forgotPassword(values));
    },
    [dispatch]
  );

  return (
    <CenteredPage title={success ? 'Password reset' : 'Forgot password'}>
      <ForgotPasswordForm
        error={error}
        submitting={submitting}
        success={success}
        onSubmit={handleSubmit}
      />
    </CenteredPage>
  );
};

export default ForgotPasswordRouteComponent;
